/*
tslint:disable:import-spacing no-inferrable-types
variable-name align no-trailing-whitespace component-class-suffix
no-string-literal component-selector
*/

import {DecisionPoint}  from '@/models/scenario/decision.point';
import {WorkType}       from '@/models/scenario/work.block';
import {Period}         from '@/util/period';

/**
 *
 * @class WorkBlockInlineEdit
 *
 * @brief basic interface for working with edits to single columns; allows usu to publish
 * edits from one view of the work blocks to the other views, i.e. from the input edit pane
 * to any of the summary views
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      June 2020
 *
 */
export class WorkBlockInlineEdit {

  /** the workblock being modified */
  public id: number;

  /** the filed being modified */
  public field: string;

  /** the new value */
  public value: any;

  /** standard constructor, allow anonymous object initialization */
  public constructor(init?: Partial<WorkBlockInlineEdit>) {

    Object.assign(this, init);
  }

}
